import ApiUtil from '../utils/ApiUtil';
import { type ComplaintAttributesType } from 'types/services';
import { complaintsServiceUrls } from 'constants/apiEndPoints';
import QueryParamsBuilder from 'components/helpers/commonFunctions/QueryParamsBuilder';
import { type ComplaintFilterType } from 'pages/Complaints';


const getAllComplaints = async (page: number, size: number, sortBy: string, sortOrder: string, searchValue: string, filters: unknown): Promise<ComplaintAttributesType> => {
    let url = QueryParamsBuilder({ baseUrl: complaintsServiceUrls.getAllComplaints, page, size, sortBy, sortOrder, searchValue });

    const filterParams = new URLSearchParams();
    if (filters) {
        if (filters.startDate) {
            filterParams.append('startDate', filters.startDate);
        }

        if (filters.endDate) {
            filterParams.append('endDate', filters.endDate);
        }

        if (filters.status) {
            const status = filters.status || '';
            filterParams.append('status', status);
        }
    }

    if (filterParams.toString()) {
        url += `&${filterParams.toString()}`;
    }
    return await ApiUtil.getWithToken(url) as ComplaintAttributesType;
}

const getComplaintByComplaintId = async (complaintId: number | string): Promise<ComplaintAttributesType> => {

    return await ApiUtil.getWithToken(`${complaintsServiceUrls.getComplaintByComplaintId}${complaintId}`) as ComplaintAttributesType;


}

const getComplaintByUserId = async (userId: number | string, page: number, size: number): Promise<ComplaintAttributesType> => {

    return await ApiUtil.getWithToken(`${complaintsServiceUrls.getComplaintByUserId}${userId}?page=${page}&size=${size}`) as ComplaintAttributesType;


}


const createComplaints = async (data: ComplaintAttributesType): Promise<ComplaintAttributesType> => {
    return await ApiUtil.postWithToken('create-complaints', data) as ComplaintAttributesType;

}

const updateComplaintStatus = async (complaintId: number, data: { status: string, userId: number }): Promise<string> => {

    try {
        await ApiUtil.putWithToken(`update-complaint-status/${complaintId}`, data);
        return 'Successfully status updated ';
    } catch (error) {
        throw new Error(`Unable to change status. ${String(error)}`);
    }
};


const exportComplaints = async (filters: ComplaintFilterType): Promise<string> => {
    try {
        let url = complaintsServiceUrls.exportComplaints;
        const filterParams = new URLSearchParams();

        if (filters) {
            if (filters.startDate) {
                filterParams.append("startDate", filters.startDate);
            }
            if (filters.endDate) {
                filterParams.append("endDate", filters.endDate);
            }
            if (filters.status) {
                filterParams.append("status", filters.status);
            }
        }

        if (filterParams.toString()) {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            url += `?${filterParams.toString()}`;
        }

        const res = await ApiUtil.getExcelFile(url);

        const blob = new Blob([res?.data], { type: res?.headers["content-type"] });
        const fileUrl = URL.createObjectURL(blob);

        return fileUrl;
    } catch (error) {
        console.error("Export Complaints Error:", error);
        throw error; // Re-throw for the calling function to handle
    }
};




export {
    getAllComplaints,
    createComplaints,
    getComplaintByComplaintId,
    getComplaintByUserId,
    updateComplaintStatus,
    exportComplaints
}